(() => {
  const root = document.body;
  if (!root.classList.contains('aera-kaoli-page')) return;
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');
  root.querySelectorAll('.animate--hidden').forEach(el => {el.classList.remove('animate--hidden'); el.classList.add('animate--shown');});
  root.querySelectorAll('comparison-slider').forEach(slider => {
    const input = slider.querySelector('input[type="range"]');
    const update = () => {
      const value = input.value + '%';
      slider.style.setProperty('--position', value);
      slider.querySelector('.comparison-slider__overlay').style.width = value;
      slider.querySelector('.comparison-slider__line').style.left = value;
      const before=slider.querySelector('.comparison-slider__overlay img');if(before){before.style.width=slider.clientWidth+'px';before.style.maxWidth='none';}
    };
    input?.addEventListener('input', update); if(input) update();new ResizeObserver(update).observe(slider);
  });
  root.querySelectorAll('media-gallery').forEach(gallery => {
    const list = gallery.querySelector('[id^="Slider-Gallery"]');
    if(!list) return;
    const slides = [...list.children]; let current = 0;
    const show = index => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {slide.classList.toggle('is-active', i === current); slide.hidden = i !== current;});
      gallery.querySelectorAll('.thumbnail-list__item').forEach((item,i) => {const btn=item.querySelector('button');if(btn)btn.setAttribute('aria-current', i===current?'true':'false');});
      gallery.querySelectorAll('.slider-counter--current').forEach(el => el.textContent = current+1);
      gallery.querySelectorAll('.slider-counter__link').forEach((button,i)=>{button.classList.toggle('slider-counter__link--active',i===current);button.setAttribute('aria-current',i===current?'true':'false');});
    };
    gallery.querySelectorAll('.thumbnail-list__item').forEach((item,i) => item.querySelector('button')?.addEventListener('click',()=>show(i)));
    gallery.querySelectorAll('.slider-button').forEach(button => {button.disabled=false;button.addEventListener('click',()=>show(current+(button.name==='previous'?-1:1)));});
    gallery.querySelectorAll('.slider-counter__link').forEach((button,i)=>button.addEventListener('click',()=>show(i)));
    let start;list.addEventListener('touchstart',e=>start=e.changedTouches[0].clientX,{passive:true});
    list.addEventListener('touchend',e=>{const diff=e.changedTouches[0].clientX-start;if(Math.abs(diff)>40)show(current+(diff<0?1:-1));},{passive:true});
    show(0);
  });
  root.querySelectorAll('modal-opener button').forEach(button => button.addEventListener('click',()=>{
    const img = button.closest('li')?.querySelector('img'); if(!img)return;
    const dialog=document.createElement('dialog');dialog.className='aera-kaoli-image-dialog';
    const close=document.createElement('button');close.textContent='×';close.setAttribute('aria-label','Close image');close.onclick=()=>dialog.close();
    const image=img.cloneNode();dialog.append(close,image);root.append(dialog);dialog.addEventListener('close',()=>dialog.remove());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});dialog.showModal();
  }));
  let aeraAdding = false;
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-aera-kaoli-form] button[type="submit"],sticky-atc button[form]');
    if(!button)return;event.preventDefault();event.stopImmediatePropagation();
    if(button.disabled||aeraAdding)return;
    const form=button.closest('[data-aera-kaoli-form]')||document.getElementById(button.getAttribute('form'));
    if(form)addAeraForm(form);
  },true);
  async function addAeraForm(form) {
      if(aeraAdding)return;aeraAdding=true;
      const buttons=[...root.querySelectorAll('[data-aera-kaoli-form] button[type="submit"],sticky-atc button[form]')];
      const labels=[...root.querySelectorAll('.main-atc__label__text,.sticky-atc__label__text')].map(el=>({el,text:el.textContent}));labels.forEach(({el})=>el.textContent='Adding…');
      buttons.forEach(button=>{button.disabled=true;button.setAttribute('aria-busy','true');});
      let error=form.querySelector('[data-aera-error]');if(error)error.remove();
      try {
        const body=new FormData(form);
        for(const [key,value] of body.entries()){
          if(key.includes('__kaching_bundles')&&typeof value==='string'&&!value.trim().startsWith('{')){
            try{const decoded=atob(value);JSON.parse(decoded);body.set(key,decoded);}catch(_){}
          }
        }
        if(!body.has('quantity')&&!body.has('items[0][quantity]'))body.set('quantity','1');
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',credentials:'same-origin',body,headers:{Accept:'application/json'}});
        const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||'Unable to add this item. Please try again.');
        if(window.AeraKaoliCart)await window.AeraKaoliCart.open();else location.assign('/cart');
      } catch(e) {
        error=document.createElement('p');error.dataset.aeraError='true';error.setAttribute('role','alert');error.textContent=e.message;form.append(error);
      } finally {
        aeraAdding=false;buttons.forEach(button=>{button.disabled=false;button.removeAttribute('aria-busy');});
        labels.forEach(({el,text})=>el.textContent=text);
      }
  }
  root.querySelectorAll('[data-aera-kaoli-form]').forEach(form=>form.addEventListener('submit',event=>{event.preventDefault();event.stopImmediatePropagation();addAeraForm(form);},true));
  root.querySelectorAll('sticky-atc button[form]').forEach(button=>button.addEventListener('click',()=>document.getElementById(button.getAttribute('form'))?.requestSubmit()));
  root.querySelectorAll('sticky-atc[data-after-scroll]').forEach(sticky=>{
    const form=root.querySelector('[data-aera-kaoli-form]');if(!form)return;
    const update=()=>{sticky.dataset.afterScroll=String(form.getBoundingClientRect().bottom>0);};
    window.addEventListener('scroll',update,{passive:true});update();
  });
  root.querySelectorAll('header-drawer details').forEach(details=>details.addEventListener('toggle',()=>details.classList.toggle('menu-opening',details.open)));
  root.querySelectorAll('.menu-drawer__close-button,.menu-drawer__close-menu-btn').forEach(button=>button.addEventListener('click',()=>{const details=button.closest('header-drawer')?.querySelector('details');if(details)details.open=false;}));
  root.querySelectorAll('form[action="/contact"]').forEach(form=>{
    if(!form.querySelector('[name="form_type"]')){const input=document.createElement('input');input.type='hidden';input.name='form_type';input.value='customer';form.append(input);}
  });
})();
